import { Injectable }       from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { DEFAULT_LANGUAGE } from './internationalization.constants';

@Injectable({
  providedIn: 'root'
})
export class TranslateConfigService {
  _defaultLanguage = DEFAULT_LANGUAGE;

  constructor (
    private translateService: TranslateService
  ) {}

  /**
   * Even though the session service has been upgraded,
   * there is an error when trying to inject it here:
   *
   * Error: Trying to get the AngularJS injector before it being set.
   *
   * It unknown what is wrong that is causing this but until we find out,
   * we need to manually get the session object.
   */
  getSessionLanguage () : string {
    const session  = sessionStorage.session_object
      ? JSON.parse(sessionStorage.session_object)
      : {};

    return session ?
      ( session.company_settings?.language || this._defaultLanguage )
      : this._defaultLanguage;
  }

  init () : void {
    this.translateService.setDefaultLang(this._defaultLanguage);

    this.setLanguage();
  }

  setLanguage ( language = this.getSessionLanguage() ) : void {
    this.translateService.use(language);
  }
}